module.exports = __webpack_public_path__ + "static/10-dded9b0aa6e94e19e0f27a638d500d7c.jpg";